import React from "react"
import { Link } from "gatsby"
import "./tiles.scss"

const Tiles = ({ data }) => {
  return (
    <section className="tiles">
      {data.map((props, idx) => (
        <Tile {...props} key={idx} />
      ))}
    </section>
  )
}

export default Tiles

export const Tile = (
  { backgroundImage, foregroundImage, noFilter, link },
  idx
) => {
  const styles = {
    backgroundImage: `url(${backgroundImage})`,
  }

  if (noFilter) {
    styles.opacity = 1
  }

  return (
    <div className="tile" key={idx}>
      {link ? (
        <Link to={link}>
          <div className="bg" style={styles}></div>
          <img src={foregroundImage} alt="" />
        </Link>
      ) : (
        <>
          <div className="bg" style={styles}></div>
          <img src={foregroundImage} alt="" />
        </>
      )}
    </div>
  )
}
